var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"BaseHeading",class:_vm.classes},[(_vm.preheading)?_c('em',[_vm._v("\n        "+_vm._s(_vm.preheading)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.tag)?_c('HeadingElement',{attrs:{"tag":_vm.tag},domProps:{"innerHTML":_vm._s(_vm.heading)}}):_c('hgroup',{domProps:{"innerHTML":_vm._s(_vm.heading)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }